import './Career.scss';
import careerImg from '../assets/career.png';
import {useRef, useState, useEffect} from 'react';
import {Stack, Accordion, Container, Card} from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import ScrollToTop from '../components/ScrollToTop';

function PreInterviewForm({setactivelink}) {
   
  return (
    <Stack setactivelink={setactivelink} id="career" gap={6} className="career">
        <ScrollToTop /> 
        <Container className="py-4">  
             <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfsFzbgYDd8kOlHf1giVE-g8YGaPHpH4mDuoH_8Iw7bgsMi9g/viewform?embedded=true" width="100%" height="3750" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </Container>
    </Stack>
  )};

  export default PreInterviewForm;